import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Loadable, LoadableOf, UnbalanceUnit } from '@schenck/rotec-components';
import { Observable, of } from 'rxjs';
import { catchError, map, shareReplay, startWith } from 'rxjs/operators';
import { apiBaseUrl } from 'src/config';
import { StatisticsApiRequest, replaceDatesWithISOStrings } from './model';
import { MockDataService } from 'src/services/utils/mock-data.service';

interface ApiRequest {
  main: {
    from: string;
    to: string;
    machineSerials: string[];
    unbalUnit?: UnbalanceUnit;
  };
  compare?: {
    from: string;
    to: string;
    machineSerials: string[];
    unbalUnit?: UnbalanceUnit;
  };
  unbalUnit?: UnbalanceUnit;
}

@Injectable()
export class DataApi {
  protected http = inject(HttpClient);
  private readonly mockService = inject(MockDataService);

  /**
   * Get all rotor types regardless of time span and machines.
   */
  getRotorType$(dateFrom: string | null, dateTo: string | null): Observable<string[]> {
    return this.http.get<string[]>(
      `${apiBaseUrl}/data/rotortypes/all${
        dateFrom !== null || dateTo !== null ? '?dateFrom=' + dateFrom + '&dateTo=' + dateTo : ''
      }`
    );
  }

  get$<Data, Request extends StatisticsApiRequest = StatisticsApiRequest>(
    url: string,
    request: Request,
    useMock: boolean = false
  ): Observable<LoadableOf<Data>> {
    if (useMock) {
      return this.mockService.getMock$(url, request);
    }

    return this.http
      .post<Data>(`${apiBaseUrl}/data/${url}`, _replaceDatesWithISOStrings(request))
      .pipe(
        map((response) => Loadable.done(response)),
        catchError(() => of(Loadable.error())),
        startWith(Loadable.loading()),
        shareReplay(1)
      );
  }
}

function _replaceDatesWithISOStrings(request: StatisticsApiRequest) {
  const apiRequest: ApiRequest = {
    main: {
      ...request.main,
      ...replaceDatesWithISOStrings(request.main),
    },
  };
  if (request.compare) {
    apiRequest.compare = {
      ...request.compare,
      ...replaceDatesWithISOStrings(request.compare),
    };
  }
  return { ...request, ...apiRequest };
}
